export default function reducer(
  state = {
    insightsData: '',
    latLngUpdate: true,
    periodValue: '',
  },
  action
) {
  switch (action.type) {
    case 'GET_INSIGHTS_DATA_BUILDER_STARTED': {
      return { ...state, changingStatus: 'ongoing' };
    }
    case 'GET_INSIGHTS_DATA_BUILDER_SUCCESS': {
      let data = [];
      const updatedData = action.payload;
      // updatedData.estimatedReach = action.payload.id.estimatedReach;
      // updatedData.estimatedImpressions = action.payload.id.estimatedImpressions;
      if (action.payload.status) {
        data = action.payload.id.aggregatedInsights.map((value) => {
          const listData = value;
          listData.data = JSON.parse(value.data);
          return listData;
        });
      }
      updatedData.id = data;
      return {
        ...state,
        changingStatus: 'success',
        insightsData: updatedData,
        latLngUpdate: false,
      };
    }
    case 'GET_INSIGHTS_DATA_BUILDER_FAILED': {
      return {
        ...state,
        changingStatus: 'failed',
        insightsData: action.payload,
      };
    }
    case 'GET_INSIGHTS_DATA_BUILDER_STATUS': {
      return {
        ...state,
        latLngUpdate: true,
      };
    }
    case 'GET_INSIGHT_PERIOD_UPDATE': {
      return {
        ...state,
        periodValue: action.payload.period,
      };
    }
    default: {
      return state;
    }
  }
}
